module.exports = __webpack_public_path__ + "static/media/animacao_paul_standby.ae4c342d.gif";